// import { User } from "@/models/user";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { ChannelState } from "@/types/channel";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { Module } from "vuex";
import { Channel } from "@/models/channel";

const state: ChannelState = {
  single: new Channel(),
  pagination: new Pagination(),
};

export const channel: Module<ChannelState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
